module.exports = __webpack_public_path__ + "static/media/art39.cb4297bf.jpg";